import type { SelectedVariantKeys, VariantValue } from '@libs/algolia';

import ColorToggle from '@app/pdp/components/ColorToggle/ColorToggle';
import { useProductDetails } from '@app/pdp/hooks';

import { handleVariantDisplay } from './utils';

type ProductVariantColorToggleProps = {
    variants: Record<string, VariantValue[] | undefined>;
    onChange: (value: string, key: string) => void;
};

export default function ProductVariantColorToggle({
    variants,
    onChange,
}: ProductVariantColorToggleProps) {
    const { selectedVariants } = useProductDetails();

    const colorVariants = Object.entries(variants ?? {});

    return colorVariants.map(
        ([key, colors]) =>
            colors &&
            colors.length > 0 && (
                <ColorToggle
                    className="size-variant__fields"
                    key={key}
                    variantKey={key as SelectedVariantKeys}
                    title={handleVariantDisplay(key)}
                    label={`Select a ${key}`}
                    selectedValue={selectedVariants[key as SelectedVariantKeys]}
                    toggleColors={value => onChange(value, key)}
                    items={colors ?? []}
                />
            )
    );
}
